import React, { useContext, useEffect } from "react";
import { ProgressBarFeeContainer } from "../../../containers";
import { withAppLayout } from "../../../hoc";
import { useHistory } from "react-router";
import {
  ManageFeeProvider,
  manageFeeStore,
  setManageFeeSelectedMenu,
} from "../../../contexts";
import { Col, Row } from "react-bootstrap";
import { get, isEmpty } from "lodash";
import { LoaderWrapper } from "../../../components";
import { CREATE_FEE_MENU } from "../../../utils";
import { ManageFeeRoutes } from "../../../routes";
import { useRequest } from "../../../abstracts";
import { getFeeDetailsById } from "../../../services";

export const CreateFee = (props) => {
  const history = useHistory();
  const { location } = props;
  const { state, dispatch } = useContext(manageFeeStore);
  const isLoading = get(state, "isLoading", false);
  const innerDetailsFlag = get(state, "innerDetailsFlag", false);
  useEffect(() => {
    dispatch(setManageFeeSelectedMenu(location.pathname));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  useEffect(() => {
    if (innerDetailsFlag) {
    }
  }, [innerDetailsFlag]);

  return (
    <LoaderWrapper isLoading={isLoading} className="row manage-company-wrapper">
      <Row sm="12" className="h-100">
        <Col
          className="manage-master-column manage-menu-items"
          style={{ paddingRight: "0px" }}
        >
          <ProgressBarFeeContainer
            history={history}
            menuList={CREATE_FEE_MENU}
            selectedMenu={get(state, "selectedMenu")}
          />
        </Col>
        <Col className="app-outer-layout">
          <ManageFeeRoutes />
        </Col>
      </Row>
    </LoaderWrapper>
  );
};
const CreateFeeWithProvider = (props) => {
  return (
    <ManageFeeProvider>
      <CreateFee {...props} />
    </ManageFeeProvider>
  );
};
export default withAppLayout(CreateFeeWithProvider);
